import { publishUsername } from './PublishStore';

export const updatePublishUsername = (value) => publishUsername.update((oldValue) => value);
